const defaultGameSettings = {
  soundEffects: true,
  autoPlayTts: true,
  darkMode: false,
  // Live colouring of the input as you type. On by default so nothing changes
  // for existing players. Only affects the colouring — Submit and the
  // attempt-vs-expected comparison are available either way.
  colorHints: true,
  // Whether capitalisation has to match. On by default: it's the existing
  // behaviour, and for German nouns or sentence-initial caps it's part of
  // writing the language correctly rather than a typo.
  caseSensitive: true,
  // Set once the player closes the settings panel. Until then it opens itself
  // on every challenge, because nothing else makes it discoverable.
  settingsDismissed: false
};

export default defaultGameSettings;
